/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import useRouter from 'js/lib/useRouter';
import user from 'js/lib/user';

import { Button, Typography } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/articles';

import 'css!bundles/collections/components/__styles__/RegistrationPromptBanner';

const styles = {
  registrationPromptBanner: css`
    background-color: var(--cds-color-callouts-tertiary);
    padding-top: 3rem;
    padding-bottom: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  buttonCta: css`
    background-image: linear-gradient(to right, var(--cds-color-blue-300), var(--cds-color-blue-500)) !important;
    border: none;
    padding: 20px 60px;
    margin-top: 32px;
  `,
  promptText: css`
    width: 840px;
    text-align: center;
    font-weight: 300;
  `,
};

const RegistrationPromptBanner = () => {
  const router = useRouter();

  const handleCTAClick = () => {
    router.replace({
      pathname: router.location.pathname,
      query: { ...router.location.query, authMode: 'signup' },
    });
  };

  if (user.isAuthenticatedUser()) {
    return null;
  }
  return (
    <section css={styles.registrationPromptBanner}>
      <Typography component="p" color="invertBody" variant="d2" css={styles.promptText}>
        {_t('Register to learn with Coursera’s community of #{amount} million learners around the world', {
          amount: '87',
        })}
      </Typography>
      <Button
        variant="ghostInvert"
        trackingName="banner_cta"
        withVisibilityTracking={false}
        requireFullyVisible={false}
        component={TrackedButton}
        css={styles.buttonCta}
        onClick={() => handleCTAClick()}
        data-elementtiming="frontpage.banner.cta"
      >
        {_t('Join for Free')}
      </Button>
    </section>
  );
};

export default RegistrationPromptBanner;
